import type { VariantDraft } from '@/lib/variants';

export interface VariantTemplate {
  id: string;
  label: string;
  names: readonly string[];
}

/**
 * Atalhos fixos de digitação. Eles não são atributos e não geram matriz:
 * cada nome ainda vira exatamente uma linha filha em `products`.
 */
export const VARIANT_TEMPLATES: readonly VariantTemplate[] = [
  { id: 'color', label: 'Cor', names: ['Preto', 'Branco', 'Azul', 'Vermelho'] },
  { id: 'gender', label: 'Gênero', names: ['Feminino', 'Masculino', 'Unissex'] },
  { id: 'voltage', label: 'Voltagem', names: ['110V', '220V', 'Bivolt'] },
  {
    id: 'sweet_flavor',
    label: 'Sabor Doces',
    names: ['Chocolate', 'Morango', 'Baunilha', 'Doce de leite'],
  },
  {
    id: 'savory_flavor',
    label: 'Sabor Salgados',
    names: ['Carne', 'Frango', 'Queijo', 'Presunto e queijo'],
  },
  {
    id: 'pants_size',
    label: 'Tamanho Calças',
    names: ['36', '38', '40', '42', '44', '46', '48', '50'],
  },
  {
    id: 'shirt_size',
    label: 'Tamanho Camisas',
    names: ['PP', 'P', 'M', 'G', 'GG', 'XG'],
  },
  { id: 'standard_size', label: 'Tamanho Padrão', names: ['P', 'M', 'G', 'GG'] },
  {
    id: 'kids_size',
    label: 'Tamanho Infantil',
    names: ['2', '4', '6', '8', '10', '12', '14', '16'],
  },
] as const;

function normalizedName(value: string): string {
  return value.trim().toLocaleLowerCase('pt-BR');
}

/**
 * Preserva cada draft existente, inclusive preço/custo/códigos e edições do
 * nome, e apenas acrescenta os nomes ainda ausentes. Aplicar duas vezes é
 * idempotente; trocar de modelo também nunca apaga o trabalho já feito.
 */
export function applyVariantTemplate(
  current: readonly VariantDraft[],
  template: VariantTemplate,
  createDraft: (name: string, index: number) => VariantDraft,
): VariantDraft[] {
  const seen = new Set(
    current
      .map((draft) => normalizedName(draft.variant_name))
      .filter(Boolean),
  );
  const added: VariantDraft[] = [];

  for (const name of template.names) {
    const normalized = normalizedName(name);
    if (!normalized || seen.has(normalized)) continue;
    seen.add(normalized);
    added.push(createDraft(name, current.length + added.length));
  }

  return [...current, ...added];
}
